import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusCircle, List, CheckCircle, UserPlus, Save } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import Footer from '../components/Footer';
import JoinAsCoHostModal from '../components/JoinAsCoHostModal';

const HostCoHostPage = () => {
  const navigate = useNavigate();
  const [showJoinModal, setShowJoinModal] = useState(false);

  const actions = [
    {
      id: 'create',
      title: 'Create Event',
      description: 'Start planning celebration',
      icon: PlusCircle,
      color: 'from-blue-500 to-blue-600',
      bgColor: 'from-blue-50 to-blue-100',
      borderColor: 'border-blue-300',
      action: () => navigate('/select-plan')
    },
    {
      id: 'events',
      title: 'My Events',
      description: 'View and manage events',
      icon: List,
      color: 'from-purple-500 to-purple-600',
      bgColor: 'from-purple-50 to-purple-100',
      borderColor: 'border-purple-300',
      action: () => navigate('/dashboard')
    },
    {
      id: 'approvals',
      title: 'Approvals',
      description: 'Manage pending requests',
      icon: CheckCircle,
      color: 'from-green-500 to-green-600',
      bgColor: 'from-green-50 to-green-100',
      borderColor: 'border-green-300',
      action: () => navigate('/approvals-dashboard')
    },
    {
      id: 'join-cohost',
      title: 'Join as Co-host',
      description: 'Request co-host access',
      icon: UserPlus,
      color: 'from-orange-500 to-orange-600',
      bgColor: 'from-orange-50 to-orange-100',
      borderColor: 'border-orange-300',
      action: () => setShowJoinModal(true)
    },
    {
      id: 'saved',
      title: 'Saved Events',
      description: 'Resume drafts & edit',
      icon: Save,
      color: 'from-yellow-500 to-yellow-600',
      bgColor: 'from-yellow-50 to-yellow-100',
      borderColor: 'border-yellow-300',
      action: () => navigate('/saved-events')
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-contribo-navy from-opacity-5 via-contribo-gold via-opacity-5 to-blue-50">
      {/* Header - Mobile Optimized */}
      <div className="max-w-6xl mx-auto px-4 pt-4">
        <div className="text-center py-6 bg-gradient-to-r from-contribo-navy to-contribo-gold rounded-lg">
          <h1 className="text-2xl font-bold text-white mb-2">
            Host & Co-host <span className="text-yellow-300">Dashboard</span>
          </h1>
          <p className="text-sm text-white font-semibold">
            Create and manage your events with ease
          </p>
        </div>
      </div>

      {/* Action Cards - 2x2 Grid for 360px */}
      <div className="max-w-6xl mx-auto px-2 pb-20">
        <div className="grid grid-cols-2 gap-3 mt-6">
          {actions.map((action) => {
            const Icon = action.icon;
            return (
              <Card
                key={action.id}
                className={`cursor-pointer hover:scale-105 transition-all duration-300 border-2 ${action.borderColor} shadow-lg bg-gradient-to-br ${action.bgColor}`}
                onClick={action.action}
              >
                <CardContent className="p-4 text-center">
                  <div className={`w-14 h-14 mx-auto mb-3 rounded-full bg-gradient-to-br ${action.color} flex items-center justify-center shadow-md`}>
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h2 className="text-sm font-bold text-gray-900 mb-1 leading-tight">
                    {action.title}
                  </h2>
                  <p className="text-[11px] text-gray-600 leading-tight">
                    {action.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>

      {/* Join as Co-host Modal */}
      <JoinAsCoHostModal 
        isOpen={showJoinModal}
        onClose={() => setShowJoinModal(false)}
      />

      <Footer />
    </div>
  );
};

export default HostCoHostPage;
